module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list-cn@2x.470e2ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list-cn@2x.png
// module id = vKwo
// module chunks = 18